import React, { useLayoutEffect, useState } from 'react';
import { GTMProvider } from '@elgorditosalsero/react-gtm-hook';
import type { AppProps } from 'next/app';
import { isMiniProgram } from '@/utils/wechat';

// 用于谷歌gtm ；在需要使用的page使用，传入包裹页面，传入state（gtmId）；
const withGTM = (Component: React.VFC<any> | AppProps['Component'], GTMState: any) => (props: any) => {
  const [injectScript, setInjectScript] = useState(false);

  useLayoutEffect(() => {
    if (!isMiniProgram()) {
      setInjectScript(true);
    }
  }, []);

  return (
    <GTMProvider state={{ ...GTMState, injectScript }}>
      <Component {...props} />
    </GTMProvider>
  );
};

export default withGTM;
